module.exports = __webpack_public_path__ + "static/img/swiper4.5c1549d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/swiper4.jpg
// module id = oKWR
// module chunks = 1